import React from "react";
import CallSessionSheet from "../../CallSessionSheet";
import { track } from "../../../analytics";

// Deep link /:awb?createCallSession=true: the session is created on page load
// (useCallSession). Uses the shared call session modal.
const CallSessionModal = ({ isOpen, onClose, onRetry, phoneNumber, loading, error, loadingStage }) => {
  if (!isOpen) return null;
  const status = loading ? "loading" : error ? "error" : phoneNumber ? "success" : "loading";
  return (
    <CallSessionSheet
      status={status}
      number={phoneNumber}
      error={error ? "We couldn't connect you to your Kaptaan right now. Please try again in a moment." : ""}
      loadingText={loadingStage === "radar" ? "Fetching your trip details…" : "Creating a secure call line to your Kaptaan…"}
      onClose={onClose}
      onRetry={onRetry}
      onCallNow={() => track("tp_call_session", { step: "call_now", via: "deep_link" })}
      onCopy={() => track("tp_call_session", { step: "copy", via: "deep_link" })}
    />
  );
};

export default CallSessionModal;
